/**
 * KAUL_CHILD_THEME_ActionCardReadMore
 * Expands card copy in place with a smooth height transition.
 */
class KAUL_CHILD_THEME_ActionCardReadMore {
    constructor(root = document) {
        this.root = root;
        this.groups = Array.from(this.root.querySelectorAll('.homepage-action-cards'))
            .map((container) => ({
                container,
                cards: Array.from(container.querySelectorAll('.action-card')),
            }))
            .filter((group) => group.cards.length > 0);

        if (this.groups.length === 0) {
            return;
        }

        this.init();
    }

    init() {
        const resizeHandler = () => {
            this.measureAllCards();
            this.groups.forEach((group) => {
                group.cards.forEach((card) => {
                    this.syncCardState(card, card.classList.contains('is-expanded'));
                });
            });
        };

        this.resizeHandler = resizeHandler;
        window.addEventListener('resize', this.resizeHandler);

        this.groups.forEach((group) => {
            group.cards.forEach((card) => {
                const textWrap = card.querySelector('.action-card__text--split');
                const preview = card.querySelector('.action-card__text-preview');
                const full = card.querySelector('.action-card__text-full');
                const button = card.querySelector('.action-card__read-more');

                if (!textWrap || !preview || !full || !button) {
                    return;
                }

                button.addEventListener('click', (event) => {
                    event.preventDefault();

                    const isExpanded = ! card.classList.contains('is-expanded');

                    if (isExpanded) {
                        this.collapseOtherCards(card);
                    }

                    this.syncCardState(card, isExpanded);
                });

                card.classList.add('is-ready');
            });
        });

        this.measureAllCards();
        this.groups.forEach((group) => {
            group.cards.forEach((card) => {
                this.syncCardState(card, false);
            });
        });
    }

    collapseOtherCards(activeCard) {
        this.groups.forEach((group) => {
            group.cards.forEach((card) => {
                if (card !== activeCard) {
                    this.syncCardState(card, false);
                }
            });
        });
    }

    measureAllCards() {
        this.groups.forEach((group) => {
            group.cards.forEach((card) => {
                const preview = card.querySelector('.action-card__text-preview');
                const full = card.querySelector('.action-card__text-full');

                if (!preview || !full) {
                    return;
                }

                preview.style.maxHeight = 'none';
                full.style.maxHeight = 'none';
                full.style.opacity = '1';
                full.style.transform = 'translateY(0)';

                const previewHeight = Math.ceil(preview.scrollHeight);
                const fullHeight = Math.ceil(full.scrollHeight);

                card.dataset.actionCardPreviewHeight = String(previewHeight);
                card.dataset.actionCardFullHeight = String(fullHeight);
                preview.style.maxHeight = `${previewHeight}px`;
                full.style.maxHeight = '0px';
                full.style.opacity = '0';
                full.style.transform = 'translateY(-4px)';
            });
        });
    }

    syncCardState(card, isExpanded) {
        const preview = card.querySelector('.action-card__text-preview');
        const full = card.querySelector('.action-card__text-full');
        const button = card.querySelector('.action-card__read-more');

        if (!preview || !full || !button) {
            return;
        }

        const targetPreviewHeight = Number(card.dataset.actionCardPreviewHeight || preview.scrollHeight);
        const targetFullHeight = Number(card.dataset.actionCardFullHeight || full.scrollHeight);

        card.classList.toggle('is-expanded', isExpanded);
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        const moreLabel = button.querySelector('.action-card__read-more-label--more');
        const lessLabel = button.querySelector('.action-card__read-more-label--less');

        if (moreLabel) {
            moreLabel.hidden = isExpanded;
        }

        if (lessLabel) {
            lessLabel.hidden = ! isExpanded;
        }

        preview.style.maxHeight = isExpanded ? '0px' : `${targetPreviewHeight}px`;
        preview.style.opacity = isExpanded ? '0' : '1';
        preview.style.transform = isExpanded ? 'translateY(-4px)' : 'translateY(0)';

        full.style.maxHeight = isExpanded ? `${targetFullHeight}px` : '0px';
        full.style.opacity = isExpanded ? '1' : '0';
        full.style.transform = isExpanded ? 'translateY(0)' : 'translateY(-4px)';
    }
}

export default KAUL_CHILD_THEME_ActionCardReadMore;
